module.exports = __webpack_public_path__ + "static/img/organization.e89654b1.png";